import React from 'react';
import { Box } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ProductInfo } from '../compareData';
import { ReasonIcon } from '../CompareIcons';
import { MOBILE } from '../constants';
import { ColumnBlock } from './ColumnBlock';

/** "Top reasons to buy" — an icon + one-line benefit per reason. */
export const ReasonsBlock: React.FC<{ product: ProductInfo }> = ({ product }) => {
  const { t } = useTranslation();
  return (
    <ColumnBlock title={t('compare_v2_top_reasons')}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 14, [MOBILE]: { gap: 9 } }}>
        {product.reasons.map((reason) => (
          <Box
            key={reason.labelKey}
            fw={500}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 13,
              whiteSpace: 'nowrap',
              [MOBILE]: { fontSize: 11, gap: 7, whiteSpace: 'normal', lineHeight: 1.25 },
            }}
          >
            <Box
              sx={{
                width: 18,
                height: 18,
                flex: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& svg': { width: 18, height: 18 },
                [MOBILE]: { width: 15, height: 15, '& svg': { width: 15, height: 15 } },
              }}
            >
              <ReasonIcon name={reason.icon} />
            </Box>
            {t(reason.labelKey)}
          </Box>
        ))}
      </Box>
    </ColumnBlock>
  );
};
